"use client"
import React from 'react'
import {useTekstClient} from "hooks/useTekstClient";
import Switch from "react-switch";
import {MdViewDay, MdViewHeadline} from "react-icons/md";
import { useSearchParams } from 'next/navigation'
import {useSetSearchParams} from "hooks/useSetSearchParams";

export const KennisCentrumHeader = ({total}) => {
    const {updateParam, resetParams} = useSetSearchParams()
    const searchParams = useSearchParams()
    const isWeergaveCompact = searchParams.get('cpt') === "1"
    const {tekst, isLoadingTekst} = useTekstClient()

    return <div className="flex gap-4 items-center">

        {/*BreadCrumbs*/}
        <div>
            <div onClick={resetParams} className={`font-bold cursor-pointer underline hover:text-kleur-cyan`}>{tekst('pagina:support:kenniscentrum:titel')}</div>
        </div>

        {/*Aaantal*/}
        <div >
            <small><b>{total ?? 0}</b> {tekst('pagina:support:kenniscentrum:resultaten')}</small>
        </div>

        {/*Compact switch*/}
        <div className={`ml-auto`}>
            <label title={tekst('pagina:support:kenniscentrum:weergave')}>
                <Switch
                    checked={isWeergaveCompact}
                    checkedIcon={<div style={{position: "absolute", top: '-5px', left: '5px'}}><MdViewHeadline/>
                    </div>}
                    uncheckedIcon={<div style={{position: "absolute", top: '-5px', left: '4px'}}><MdViewDay/></div>}
                    onChange={() => {
                        updateParam('cpt', isWeergaveCompact ? null : 1 )
                    }}
                    height={18}
                    width={40}
                    offColor={'#23c1f4'}
                    onColor={'#23c1f4'}
                />
            </label>
        </div>
    </div>
}